import footer from './footer.vue'
export default footer